import axios from 'axios';
import { LessonCollectionResultDto } from "@haohan/papi-dto";
import { LessonModel } from '@haohan/lesson';

type CancelablePromise<T=unknown> = Promise<T> & {
	abort?: () => void
}

export const lessonApi = {
	getById(id: number): CancelablePromise<LessonModel> {
		const controller = new AbortController();
		const req = axios.get(
			`/api/lesson/item/${id}/`,
			{signal: controller.signal}
		);
		req['abort'] = controller.abort;
		return req.then(v => v.data);
	},
	search(): CancelablePromise<LessonCollectionResultDto> {
		const controller = new AbortController();
		const req = axios.get(
			'/api/lesson/collection/',
			{signal: controller.signal}
		);
		req['abort'] = controller.abort;
		return req.then(v => v.data);
	}
}